import React from "react";
import { Search } from "lucide-react";
import { urls } from "../../../../../utils/urls";
import { useHistory } from "react-router-dom";

type TabType = "SERVICE_POS" | "SRN_HISTORY";

interface Props {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  /** Omit to hide the search box (e.g. when the page has its own filters). */
  search?: string;
  onSearchChange?: (value: string) => void;
}

const ServiceReceiptTabs: React.FC<Props> = ({
  activeTab,
  onTabChange,
  search,
  onSearchChange,
}) => {
  const navigate = useHistory();
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-4 md:px-6 py-3 md:py-4 bg-white border-b">
      {/* Tabs */}
      <div className="bg-gray-100 rounded-xl p-1 flex gap-1 overflow-x-auto">
        <button
          onClick={() => navigate.push(`${urls.purchase_service_voucher}/`)}
          className={`px-6 py-2 rounded-lg text-sm font-semibold transition
                        ${
                          activeTab === "SERVICE_POS"
                            ? "bg-white text-blue-600 shadow"
                            : "text-gray-600 hover:text-gray-800"
                        }`}
        >
          Service POs
        </button>
        <button
          onClick={() =>
            navigate.push(`${urls.purchase_service_voucher}/get-srn`)
          }
          className={`px-6 py-2 rounded-lg text-sm font-semibold transition
                        ${
                          activeTab === "SRN_HISTORY"
                            ? "bg-white text-blue-600 shadow"
                            : "text-gray-600 hover:text-gray-800"
                        }`}
        >
          SRN History
        </button>
      </div>

      {/* Search */}
      {onSearchChange && (
      <div className="relative w-full sm:w-72">
        <Search
          size={18}
          className="absolute left-3 top-1/3 -translate-y-1/3 text-gray-400"
        />
        <input
          value={search ?? ""}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search PO"
          className="w-full pl-10 pr-4 py-2 rounded-lg border bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-myPrimaryColor"
        />
      </div>
      )}
    </div>
  );
};

export default ServiceReceiptTabs;
